export default "__VITE_ASSET__C9H3du_N__"